import React from 'react';
import { ArrowRight, Hammer, PanelsTopLeft, Printer, Truck, Wrench } from 'lucide-react';
import { contactWhatsApp, scrollToSection } from '../utils/buttonActions';
import ServicesAccordion from './ui/interactive-image-accordion';
import SectionHeader from './SectionHeader';
import IndustrialButton from './IndustrialButton';

const serviceDetails = [
  {
    title: 'FLEX PRINTING',
    description: 'Outdoor banners, hoardings, backdrops, and retail displays with sharp color and durable media.',
    priceRange: 'Rs.10-Rs.70/sq ft',
    imageUrl: 'https://images.unsplash.com/photo-1773525912489-9e04df48f639?q=80&w=900&auto=format&fit=crop',
    icon: <Printer className="h-5 w-5" strokeWidth={2} />,
    features: ['1440 DPI resolution', 'Weather-ready media', 'Large sizes', 'Same-day options'],
  },
  {
    title: 'VINYL GRAPHICS',
    description: 'Vehicle wraps, wall graphics, window decals, and reflective signage with clean installation.',
    priceRange: 'Rs.25-Rs.85/sq ft',
    imageUrl: 'https://images.unsplash.com/photo-1759295199382-aa4f1bc50db2?q=80&w=900&auto=format&fit=crop',
    icon: <PanelsTopLeft className="h-5 w-5" strokeWidth={2} />,
    features: ['Eco-solvent printing', 'Lamination options', 'Cut-to-shape', '5+ year durability'],
  },
  {
    title: 'FRAME WELDING',
    description: 'MS steel and aluminum support frames built for shop boards, LED signs, and rooftop structures.',
    priceRange: 'Rs.200-Rs.1000/kg',
    imageUrl: 'https://images.unsplash.com/photo-1748348812466-8e29e1348f73?q=80&w=900&auto=format&fit=crop',
    icon: <Hammer className="h-5 w-5" strokeWidth={2} />,
    features: ['In-house fabrication', 'Powder coating', 'Rust treatment', 'Custom dimensions'],
  },
  {
    title: 'INSTALLATION',
    description: 'Site survey, mounting, electrical coordination, and post-install support for signage projects.',
    priceRange: 'Rs.500-Rs.5000',
    imageUrl: 'https://images.unsplash.com/photo-1763596304839-bac0d4aadb25?q=80&w=900&auto=format&fit=crop',
    icon: <Wrench className="h-5 w-5" strokeWidth={2} />,
    features: ['Safety protocols', 'Expert team', 'Site planning', 'Final quality check'],
  },
  {
    title: 'EVENT DISPLAYS',
    description: 'Roll-up standees, promotional counters, event banners, and quick-turnaround campaign assets.',
    priceRange: 'Rs.1500/piece',
    imageUrl: 'https://images.unsplash.com/photo-1761195689615-9469b65dac01?q=80&w=900&auto=format&fit=crop',
    icon: <Truck className="h-5 w-5" strokeWidth={2} />,
    features: ['Portable setups', 'Reusable frames', 'Bulk support', 'Fast dispatch'],
  },
];

const Services = () => {
  return (
    <section id="services" className="py-20 lg:py-28 bg-white border-b-2 border-[#0A0A0A]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-8 lg:gap-12 items-end mb-14">
          <SectionHeader
            eyebrow="Production Lines"
            title="Built For"
            accent="Big Visibility"
            copy="Choose a material path, add finishing details, and move from rough idea to production-ready quote."
          />
          <div className="industrial-note" data-reveal>
            <span>Capability stack</span>
            <strong>Print / Fabricate / Install</strong>
          </div>
        </div>

        <div className="mb-12" data-reveal>
          <ServicesAccordion items={serviceDetails} />
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5 border-t-2 border-[#0A0A0A] pt-8" data-reveal>
          <p className="max-w-xl text-[#404040] text-sm leading-relaxed">
            Need a non-standard size, frame, or installation plan? Send us the rough dimensions and we will guide the material choice.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
            <IndustrialButton onClick={() => scrollToSection('smart-quote')} testId="services-quote-btn">
              Get Smart Quote
              <ArrowRight className="ml-2 h-4 w-4" strokeWidth={2} />
            </IndustrialButton>
            <IndustrialButton onClick={() => contactWhatsApp('Hi! I need a custom signage solution.')} variant="light" testId="services-custom-btn">
              Custom Quote
            </IndustrialButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
